// Libraries
var React = require('react');

// Components
var PlayersTitle = require('./PlayersTitle');
var PlayersPlayer = require('./PlayersPlayer');

// Styles
require('./PlayersModule.scss');

class PlayersModule extends React.Component {

	// constructor(props) {
	// 	super(props);
	//
	// 	// Regroup the Players.
	// 	let reGroupedPlayers = props.data.playerGroups.map((group, groupIndex) => {
	//
	// 		let reGrouped = {};
	// 		reGrouped.section = group.section;
	//
	// 		reGrouped.players = group.players.reduce((subGroups, player, playerIndex) => {
	//
	// 			let subGroupIndex = subGroups.length - 1;
	//
	// 			if (!(playerIndex % 3)) {
	// 				subGroupIndex++;
	// 				subGroups[subGroupIndex] = [];
	// 			}
	//
	// 			subGroups[subGroupIndex].push(player);
	//
	// 			return subGroups;
	// 		}, []);
	//
	// 		return reGrouped;
	// 	});
	// }

	render() {
		return (
			<div className="Players">
				{this.props.data.playerGroups.map((group) => {
					return (
						<div className="Players__group" key={"group_cont_" + group.section.id}>
							<PlayersTitle key={"group_" + group.section.id} title={group.section.name} />
							{group.players.map((player, index) => {
								return (
									<PlayersPlayer key={group.section.id + "_" + index} {...player} />
								);
							})}
						</div>
					);
				})}
			</div>
		)
	}
}

module.exports = PlayersModule;


// WEBPACK FOOTER //
// ./src/components/Players/PlayersModule.js